import React from "react";
import cn from "./helpers/cn";
import { useTabContext, getPanelId, getTabId, } from "./TabContext";

export interface TabPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  value: unknown;
  children?: React.ReactNode;
}

// Equivalente ao TabPanel: renderiza um container com
// role="tabpanel" e só exibe os filhos quando seu `value` casa com o value
// do TabContext. Quando inativo, fica oculto via atributo `hidden`.
const TabPanel = React.forwardRef<HTMLDivElement, TabPanelProps>((props, ref) => {
  const { className, value, children, ...other } = props;
  const context = useTabContext();

  const id = getPanelId(context, value);
  const tabId = getTabId(context, value);
  const isSelected = value === context.value;

  return (
    <div
      ref={ref}
      role="tabpanel"
      aria-labelledby={tabId}
      id={id}
      hidden={!isSelected}
      className={cn("p-6", className)}
      {...other}
    >
      {isSelected && children}
    </div>
  );
});

TabPanel.displayName = "TabPanel";

export default TabPanel;
